export const isTimeBeforeNow = (date: string, timeString: string) => {
  if (!date || !timeString) return;

  const isoString = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}T${timeString.slice(0, 2)}:${timeString.slice(2)}:00`;
  const target = new Date(isoString);
  const now = new Date();

  return target < now;
};
